import React from "react";
import { Testimonial } from "./Testimonial";

export const ClientReviewGoogle = () => {
  return (
    <div className="container-fluid steps py-5">
      <div className="container py-5">
        <Testimonial/>
      </div>
    </div>
  );
};


